"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const Person_1 = require("./Person");
const typeName = 'User';
class User extends Person_1.Person {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== typeName)
            throw new Error(`Tried to create a ${typeName} from a ${ob.type} object!`);
        super(ob); // can't use this.constructor.name as will fail in lambda as gets Class name appended twice
        this.type = ob.type ?? typeName;
        this.username = ob.username;
        this.creation_date = ob.creation_date;
        this.last_login = ob.last_login;
        this.IdentityId = ob.IdentityId;
    }
    getUserAttributes() {
        return {
            username: {
                type: 'String',
                label: 'Username',
                editable: false,
                required: true,
            },
            ...super.getUserAttributes(),
            creation_date: {
                type: 'Date',
                label: 'Creation date',
                editable: false,
                required: false,
            },
            last_login: {
                type: 'Date',
                label: 'Last login',
                editable: false,
                required: false,
            },
            /** 2024 02 removed as replaced in edgeTypeMatrix */
            // Customer: {
            //   type: 'RelatedType',
            //   direction: PathDirection.parent,
            //   edgeTypeId: 'customer_has_users',
            //   editable: false,
            // },
        };
    }
}
exports.User = User;
